import { createApp } from 'vue';
import ImportAll from "../utils/import_all";

// Load all vue-components
const components = {};
ImportAll(components, require.context('../vue/components/', true, /\.vue$/));

// Create vue instance
export default function(selector) {
  const app = createApp({
    data: () => ({ gon }),
  });

  // Register components
  Object.keys(components).forEach(key => {
    app.component(key, components[key]);
  });

  // Mount the app
  app.mount(selector);
}
